module.exports = __webpack_public_path__ + "244535c4a2997df9e10b7a209f729d9e.svg";